import { isEmbedded, postMessage } from './embeddable.utils'
import config from '@/config'

const embeddablePlugin = (store) => {
  store.subscribeAction((action) => {
    if (isEmbedded()) {
      if (action.type === 'updatePresentation') {
        postMessage({
          type: 'update-presentation',
          payload: action.payload,
        })
      }
    }
  })
  store.subscribe((mutation) => {
    if (isEmbedded()) {
      if (mutation.type === 'setCurrentUser') {
        postMessage({
          type: 'set-current-user',
          payload: { id: mutation.payload?.id },
        })
        postMessage({
          type: 'set-tracking',
          payload: config.mixpanel,
        })
      }
    }
  })
}

export default embeddablePlugin
